export const DETAIL_USER_EMAIL_CHANGE = 'API|DETAIL_USER/EMAIL/CHANGE'
export const DETAIL_USER_EMAIL_CHANGE_FULFILLED = `FULFILLED_${DETAIL_USER_EMAIL_CHANGE}`
export const DETAIL_USER_EMAIL_CHANGE_PENDING = `PENDING_${DETAIL_USER_EMAIL_CHANGE}`
export const DETAIL_USER_EMAIL_CHANGE_REJECTED = `REJECTED_${DETAIL_USER_EMAIL_CHANGE}`

export const DETAIL_USER_FIRST_NAME_CHANGE = 'API|DETAIL_USER/FIRST_NAME/CHANGE'
export const DETAIL_USER_FIRST_NAME_CHANGE_FULFILLED = `FULFILLED_${DETAIL_USER_FIRST_NAME_CHANGE}`
export const DETAIL_USER_FIRST_NAME_CHANGE_PENDING = `PENDING_${DETAIL_USER_FIRST_NAME_CHANGE}`
export const DETAIL_USER_FIRST_NAME_CHANGE_REJECTED = `REJECTED_${DETAIL_USER_FIRST_NAME_CHANGE}`

export const DETAIL_USER_GET = 'API|DETAIL_USER/GET'
export const DETAIL_USER_GET_FULFILLED = `FULFILLED_${DETAIL_USER_GET}`
export const DETAIL_USER_GET_PENDING = `PENDING_${DETAIL_USER_GET}`
export const DETAIL_USER_GET_REJECTED = `REJECTED_${DETAIL_USER_GET}`

export const DETAIL_USER_GROUP_ADD = 'API|DETAIL_USER/GROUP/ADD'
export const DETAIL_USER_GROUP_ADD_FULFILLED = `FULFILLED_${DETAIL_USER_GROUP_ADD}`
export const DETAIL_USER_GROUP_ADD_PENDING = `PENDING_${DETAIL_USER_GROUP_ADD}`
export const DETAIL_USER_GROUP_ADD_REJECTED = `REJECTED_${DETAIL_USER_GROUP_ADD}`

export const DETAIL_USER_GROUP_REMOVE = 'API|DETAIL_USER/GROUP/REMOVE'
export const DETAIL_USER_GROUP_REMOVE_FULFILLED = `FULFILLED_${DETAIL_USER_GROUP_REMOVE}`
export const DETAIL_USER_GROUP_REMOVE_PENDING = `PENDING_${DETAIL_USER_GROUP_REMOVE}`
export const DETAIL_USER_GROUP_REMOVE_REJECTED = `REJECTED_${DETAIL_USER_GROUP_REMOVE}`

export const DETAIL_USER_LAST_NAME_CHANGE = 'API|DETAIL_USER/LAST_NAME/CHANGE'
export const DETAIL_USER_LAST_NAME_CHANGE_FULFILLED = `FULFILLED_${DETAIL_USER_LAST_NAME_CHANGE}`
export const DETAIL_USER_LAST_NAME_CHANGE_PENDING = `PENDING_${DETAIL_USER_LAST_NAME_CHANGE}`
export const DETAIL_USER_LAST_NAME_CHANGE_REJECTED = `REJECTED_${DETAIL_USER_LAST_NAME_CHANGE}`

export const DETAIL_USER_PASSWORD_RESET = 'API|DETAIL_USER/PASSWORD/RESET'
export const DETAIL_USER_PASSWORD_RESET_FULFILLED = `FULFILLED_${DETAIL_USER_PASSWORD_RESET}`
export const DETAIL_USER_PASSWORD_RESET_PENDING = `PENDING_${DETAIL_USER_PASSWORD_RESET}`
export const DETAIL_USER_PASSWORD_RESET_REJECTED = `REJECTED_${DETAIL_USER_PASSWORD_RESET}`
